import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';
import { Trash2 } from 'lucide-react';

function editorPreviewSource(source: string) {
  return source.replace(/^\/api\/public\/media\/([^?]+)(.*)$/, '/api/media/$1/file$2');
}

/** Editor-only controls for a full-width image. */
export function ImageView({ deleteNode, node }: NodeViewProps) {
  return (
    <NodeViewWrapper className="group relative my-4" data-type="image">
      <img
        src={editorPreviewSource(node.attrs.src as string)}
        alt={(node.attrs.alt as string | null) ?? ''}
        className="m-0 max-w-full rounded-md"
      />
      <button
        type="button"
        contentEditable={false}
        title="Afbeelding verwijderen"
        aria-label="Afbeelding verwijderen"
        className="absolute right-2 top-2 inline-flex size-8 items-center justify-center rounded-md bg-background/90 text-muted-foreground opacity-0 shadow-sm transition-all hover:bg-destructive hover:text-destructive-foreground focus:opacity-100 group-hover:opacity-100"
        onMouseDown={event => event.preventDefault()}
        onClick={deleteNode}
      >
        <Trash2 className="size-4" />
      </button>
    </NodeViewWrapper>
  );
}
